<template>
    <div class="label" v-bind:class="{['bg-'+color]: color}"><slot></slot></div>
</template>
<script>
    export default {
        name: 'Label',
        components: {},
        props:  {
            color: {
                type: String,
                default: 'grey'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Label.scss" scoped lang="scss"></style>

